// src/pages/CompanyPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Home from './Home';
import { mapProjectsToJobById } from '../utils/mapProjectsToJobById';
import { getCompanySlug } from '../utils/slugUtils';

const CompanyPage = () => {
  const { companySlug } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadJob = async () => {
      try {
        // Use mapProjectsToJobById to get job with projects in one call
        const jobData = await mapProjectsToJobById(companySlug);
        
        if (jobData) {
          setJob(jobData);
        } else {
          // Job not found, redirect to home
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Failed to fetch job:', error);
        navigate('/', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    if (companySlug) {
      loadJob();
    }
  }, [companySlug, navigate]);

  // Pass the job to Home component which will open the drawer
  return <Home job={job} loading={loading} />;
};

export default CompanyPage;

